import React from 'react'

import { SpotCampaignAsset } from './SpotCampaignAsset'
import { SpotCampaignContent, SpotCampaignContentProps } from './SpotCampaignContent'
import * as SC from './SpotCampaignMobile.style'

export const SpotCampaignMobile: React.FC<SpotCampaignContentProps> = (props) => (
  <SC.Wrapper>
    <SC.Background backgroundColor={props.bgColor}>
      <SC.Asset>
        <SpotCampaignAsset {...props} />
      </SC.Asset>
      <SC.Content>
        <SpotCampaignContent {...props} mobile={true} />
      </SC.Content>
    </SC.Background>
  </SC.Wrapper>
)
